import React from 'react';
let config = require('../../cc-config.json');
const ContactPage = () => (React.createElement("article", null,
    React.createElement("section", { className: "main-col" },
        React.createElement("h1", { className: "h2" }, "Contact"),
        React.createElement("p", null,
            "Colouring ",
            config.cityName,
            " has been designed as a sustainable, low-cost open data/knowledge exchange platform that can be replicated by other cities using its open source code."),
        React.createElement("p", null, "It is developed by a small, dedicated team at Bahrain Authority for Culture and Antiquities. We are unable to answer individual queries, but we welcome constructive comments on how to improve the site, and on other types of data and new features you might like to see."),
        React.createElement("p", null,
            "You can send us comments or ask questions on:",
            ' ',
            React.createElement("a", { href: "mailto:admin@colouring.bh" }, "admin@colouring.bh")),
        React.createElement("p", null,
            "For press enquiries please contact Bahrain Authority for Culture and Antiquities at:",
            ' ',
            React.createElement("a", { href: "mailto:colouringbahrain@culture.gov.bh" }, "colouringbahrain@culture.gov.bh"),
            "."))));
export default ContactPage;
